<template>
  <div class="flex flex-row ">
    <div class="w-full lg:w-1/2 bg-white shadow justify-around rounded m-2 p-4">
      <p class="mb-2 font-semibold text-3xl">Cruz Del Sur</p>
      <div>
        <p class="font-medium text-lg my-2">Nombre</p>
        <div class="code-container">
          <p class="my-2">{{ authUser.cdsur_nombre }}</p>
        </div>
        <p class="font-medium text-lg my-2">User</p>
        <div class="code-container">
          <p class="my-2">{{ authUser.cdsur_user }}</p>
        </div>
        <p class="font-medium text-lg my-2">ID Cliente</p>
        <div class="code-container">
          <p class="my-2">{{ authUser.cdsur_idcliente  }}</p>
        </div>
        <p class="font-medium text-lg my-2">Status</p>
        <vs-chip
          size="large"
          class="w-1/3"
          :color="cdSurAccountStatus.color"
        >{{ cdSurAccountStatus.name }}</vs-chip>
      </div>
    </div>
    <div class="w-full lg:w-1/2 bg-white shadow justify-around rounded m-2 p-4">
      <p class="mb-2 font-semibold text-3xl">Mercado Libre</p>
      <div>
        <div v-if="meliAccountStatus.name==='Activo'">
          <p class="font-medium text-lg my-2">ID Usuario</p>
          <div class="code-container">
            <p class="my-2 break-words">{{ authUser.meli_user_id }}</p>
          </div>
          <p class="font-medium text-lg my-2">Access Token</p>
          <div class="code-container">
            <p class="my-2 break-words">{{ authUser.meli_access_token }}</p>
          </div>
          <p class="font-medium text-lg my-2">Refresh Token</p>
          <div v-if="authUser.meli_refresh_token" class="code-container">
            <p class="my-2 flex-wrap break-words">{{ authUser.meli_refresh_token }}</p>
          </div>
        </div>
        <p class="font-medium text-lg my-2">Status</p>
        <vs-chip
          v-if="authUser.meli_token_valid<1 && authUser.meli_user_id!=''"
          size="large"
          class="w-2/3"
           color="red"
        >Token Invalido</vs-chip>
         <vs-button
         size="large"
          class="w-2/3"
         v-if="authUser.meli_token_valid<1 && authUser.meli_user_id!=''"
         color="success"
         @click="validaToken()"
         >
        <vs-icon  class="float-left mr-3" icon="update" size="24px" color="#fff">  </vs-icon>      
           Validar Token</span></vs-button>
        <vs-chip
        v-if="authUser.meli_token_valid>0"
          size="large"
          class="w-3/3"
          :color="meliAccountStatus.color"
        >{{ meliAccountStatus.name }}</vs-chip>

        <br><br>
        <div>
          <MeliAccount />
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import MeliAccount from '../components/MeliAuthorize'
import { mapGetters } from 'vuex'
import axios from "axios";
export default {
  
  computed: {
    authUser() {
      return this.$store.state.authUser
    },
    ...mapGetters({
      cdSurAccount: 'cdSurAccount',
      cdSurAccountStatus: 'cdSurAccountStatus',
      meliAccount: 'meliAccount',
      meliAccountStatus: 'meliAccountStatus',
      //authUser: 'authUser'
    })
  },
  
  methods:{
    validaToken(){
        axios
        .get(process.env.VUE_APP_BACKEND_URL + "api/validaToken")
        .then(() => 
          console.log("Token Validado"),
          setTimeout(() => { location.reload(); }, 2000)
        )
        .catch((error) => {
          console.log(error);
        });
    }
  },

  components:{MeliAccount}
}
</script>

<style lang="scss">
.code-container {
  background: #bbbbbb22;
  padding: 0.5em;
  border-radius: 0.4rem;
  &:hover {
    background: #bbbbbb33;
  }
}
</style>